<template lang="pug">
#laudos
    SelecionarTerritorio(
        :tipoLaudo='tipoLaudo',
        @getTerritoriosSelecionados='solicitarLaudos',
        @cancelar-modal='changeShowModalSelecionarTerritorio',
        ref='selecionarTerritorio'
    )
</template>

<script>
import SelecionarTerritorio from '@/components/laudos/SelecionarTerritorio.vue';
import TipoLaudo from '@/constants/TipoLaudo';
import LaudoService from '@/services/LaudosService';
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'Laudos',
    components: {
        SelecionarTerritorio
    },
    computed: {
        ...mapGetters(['usuarioLogado']),
        ...mapState(['usuarioIsLaudo'])
    },
    data() {
        return {
            tipoLaudo: TipoLaudo.HISTORICO_AGRICOLA,
            showModalVisualizacao: false,
            showModalSelecionarTerritorios: false,
            showModalConfirmarTerritorios: false,
            territoriosSelecionados: [],
            pageParams: {
                page: 1,
                size: 20,
                sort: 'dataCadastro,DESC'
            },
            filtros: {
                dataCadastroFim: '',
                dataCadastroInicio: '',
                dataFinalizacaoFim: '',
                dataFinalizacaoInicio: '',
                representantesCpfCnpj: [],
                situacaoId: '',
                statusId: '',
                territoriosIds: [],
                tipoLaudoId: TipoLaudo.HISTORICO_AGRICOLA
            },
            totalLaudos: 0,
            laudos: [],
            idLaudo: null,
            rowInfo: null,
            showModalInsercaoResultados: false,
            loading: false
        };
    },
    methods: {
        async getLaudos() {
            if (this.usuarioIsLaudo) {
                this.$router.push({ name: 'LaudoAvaliacaoSocioambiental' });
            }
            await this.requestLaudos();
        },

        changeShowModalSelecionarTerritorio() {
            this.showModalSelecionarTerritorios =
                !this.showModalSelecionarTerritorios;
            this.$emit('showModalSelecionarTerritorios');
        },

        solicitarLaudos(territoriosSelecionados) {
            this.changeShowModalSelecionarTerritorio();
            this.territoriosSelecionados = territoriosSelecionados;
            this.$emit('atualizarTerritoriosSelecionados', this.territoriosSelecionados);
        },

        voltar() {
            this.changeShowModalConfirmarTerritorios();
            this.getLaudos();
        },

        async requestLaudos() {
            try {
                this.loading = true;
                const { data } = await LaudoService.requestLaudos(
                    this.filtros,
                    this.pageParams
                );
                this.totalLaudos = data.totalItens;
                this.laudos = data.laudos;
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.laudos.erro.naoFoiPossivelCarregarOsDados')
                });
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
#laudos {
    .laudo-margin {
        margin-bottom: 20px;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>
